/**
 * Makes all top-level properties & selected second-level properties optional
 */
export type OptionalKeysDeep<T, K extends keyof T> = Partial<Omit<T, K>> & {
    [P in K]?: Partial<T[P]>;
};
